import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, Observable, Subject, tap, throwError } from 'rxjs';
import { DataLoginI } from 'src/app/interfaces/login/login.interface';
import { Register } from 'src/app/interfaces/register/register.interface';
import { ResponseI } from 'src/app/models/auth/response.interface';
import { environment } from 'src/environments/environment';
import { CookieService } from '../../cookie.service';
import { isPlatformBrowser } from '@angular/common';
const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  _userSessionRefreshed: Event;

  cookieDomain:string = `${environment.COOKIE_DOMAIN}`;
  loggedIn = false;
  loginAction = new Subject<any>();
  currentUser = {
    login: {
      access_token: null,
    },
    getPerson: {
      context: {
          activities: [
              {
                  personStatus: {
                      accountBalance: null,
                      accountLeft: null,
                      cartTotal: null,
                      quantityItemsInCart: null
                  }
              }
          ]
      },
      person: {
        profile: {
          address: {
            city: null,
            countryId: null,
            countryName: null,
            latitude: null,
            longitude: null,
            name: null,
            postalCode: null,
            stateId: '',
            street1: null,
            street2: null,
            type: null
          },
          ano_vehiculo: null,
          birthday: '',
          cellphone: {
            areaCode: null,
            intCode: null,
            number: null
          },
          document: {
            number: '',
            type: ''
          },
          email: '',
          emailValueState: '',
          firstname: '',
          gender: '',
          lastname: '',
          marca_auto: null,
          modelo_auto: null,
          optin_digital_shellbox: null,
          patente_auto: null,
          tipo_vehiculo: null,
          tyc_shellbox_accepted: null,
          onboarding_shellbox: null
        }
      }
    }
  };

  constructor(
      private http : HttpClient , 
      private route : Router, 
      private cookieService: CookieService,
      @Inject(PLATFORM_ID) private platformId: Object
    ) {
    this._userSessionRefreshed = new Event('UserSessionRefreshed');

  }

  /////////// LOGIN FUNCTIONS ////////////
  login(authData:DataLoginI): Observable<ResponseI>{
    let apiLoginUrl = environment.API_URL + "/auth/Login";
      return this.http
        .post<ResponseI>(apiLoginUrl,authData )
        .pipe(

          tap((res: any)  => {
            //save token
            if(res.login) {
              this.saveToken(res.login.access_token);

              this.setUser( res );
              this.saveUser(res.getPerson);
              this.saveAvatar(res.avatar?res.avatar.avatar:false);

              document.dispatchEvent(this._userSessionRefreshed);
            }
        })
        )
  }

  loginApp(token:any): Observable<ResponseI>{
    let apiLoginUrl = environment.API_URL + "/auth/AppLogin";
      return this.http
        .post<ResponseI>(apiLoginUrl,{
          shellBoxAppClientToken: token
        } )
        .pipe(

          tap((res: any)  => {
            //save token
            if(res.login) {
              this.saveToken(res.login.access_token);

              this.setUser( res );
              this.saveUser(res.getPerson);
              this.saveAvatar(res.avatar?res.avatar.avatar:false);

              document.dispatchEvent(this._userSessionRefreshed);
            }

        })
        )
  }

  //Save Token
  private saveToken(token: string) : void{
    if (!isPlatformBrowser(this.platformId)) return;
      localStorage.setItem('token', token);
      localStorage.setItem('expiration_user', new Date((new Date()).getTime() + 110*60000).getTime().toString());
  }

  // Resend email
  resendEmail(email: string): Observable<ResponseI>{
    let apiResendUrl = environment.API_URL + "/auth/ReSendVerificationEmail";
    return this.http.post<ResponseI>(apiResendUrl, {"principal": email});
  }

  //Check is set token
  async IsLoggedIn(): Promise<boolean>{
    if (!isPlatformBrowser(this.platformId)) return false;
    const token = await localStorage.getItem('token');

    return token != null && token.length > 0;
  }

  async getAccessToken(): Promise<string | null>{
    if (!isPlatformBrowser(this.platformId)) return null;
    return await localStorage.getItem('token');
}

  async IsSessionValid(): Promise<boolean>{
    if (isPlatformBrowser(this.platformId)){;
    let StoredTime : any = await localStorage.getItem('expiration_user');
    if(!StoredTime)
      return false;
    let returnValue = false;
    if(StoredTime && parseInt(StoredTime) > (new Date()).getTime()) {
      returnValue = await localStorage.getItem('token')!=null;
    }
    else
      returnValue = false;

    if(!returnValue)
    {
      this.logout();
      document.location.href = '/';
    }

    return returnValue;
  }
  return false;
}

  async checkAuth(): Promise<void>{
    if (!isPlatformBrowser(this.platformId)) return;
    const user: any = await localStorage.getItem('user');
    if (user){
      this.currentUser = JSON.parse(user);
      this.loggedIn = true;
      this.loginAction.next(true);
    }else{
      this.loggedIn = false;
      this.loginAction.next(false);
    }

  }

  async refreshUser(data: any): Promise<void> {
    const profile = data.person.profile;
    const context = data.context;

    let currentUser: any = await this.getCurrentUser();

    currentUser = JSON.parse(JSON.stringify(currentUser));

    delete currentUser.person.profile;
    delete currentUser.context;

    currentUser.person.profile = profile;
    currentUser.context = context;

    if (!isPlatformBrowser(this.platformId)) return;
    await localStorage.setItem('user', JSON.stringify(currentUser));

    document.dispatchEvent(this._userSessionRefreshed);
  }

  async saveUser(user: any): Promise<any>{
    if (!isPlatformBrowser(this.platformId)) return;
    await localStorage.setItem('user', JSON.stringify(user));

    this.loginAction.next(true);
  }

  async saveAvatar(avatar: any): Promise<any>{
    if (!isPlatformBrowser(this.platformId)) return;
    await localStorage.setItem('avatar', avatar?avatar:false);
    document.dispatchEvent(this._userSessionRefreshed);
    this.loginAction.next(true);
  }

  async getCurrentAvatar(): Promise<any>{
    if (!isPlatformBrowser(this.platformId)) return false;
    const avatar: any = await localStorage.getItem('avatar');

    if(avatar){
      return avatar;
    }else{
      return false;
    }
  }

  async getCurrentUser(): Promise<any>{
    if (!isPlatformBrowser(this.platformId)) return false;
    const user: any = await localStorage.getItem('user');

    if(user){
      return JSON.parse(user);
    }else{
      return false;
    }
  }

  async setUser(user: any): Promise<any>{
    if (!isPlatformBrowser(this.platformId)) return;
    this.currentUser = user;
    this.loggedIn = true;
    localStorage.setItem('user', JSON.stringify(user));
    this.loginAction.next(true);
  }


  async logout(): Promise<any>
  {
    if (!isPlatformBrowser(this.platformId)) return;
    this.clearToken();

    this.cookieService.deleteCookie('token', this.cookieDomain);

    await localStorage.removeItem('validateCode');

    await localStorage.removeItem('user');

    document.dispatchEvent(this._userSessionRefreshed);

    this.loginAction.next(false);

    this.loggedIn = false;
  }

  async clearToken()
  {
    if (!isPlatformBrowser(this.platformId)) return;
    await localStorage.removeItem( 'token' );
    await localStorage.removeItem( 'expiration_user' );
  }

  onLogging(): Observable<any>
  {
    return this.loginAction.asObservable();
  }

  //Show error
  private handlerError(err:any) : Observable<never> {
      let errorMessage = 'An error ocurred';
      if(err){
        errorMessage = `Error: code ${err.message}`;

      }
        return throwError(errorMessage);
  }


  register(registerData : any, local : boolean = true) : Observable<ResponseI> {
    if(local)
      var apiRegisterUrl = environment.API_URL + "/auth/registerUser";
    else
      var apiRegisterUrl = environment.API_URL + "/auth/registerUserMarketplace";

    return this.http.post<any>(apiRegisterUrl, registerData);
  }

  passwordRecover(principal : any) : Observable<ResponseI> {
    let apiRegisterUrl = environment.API_URL + "/auth/PasswordRecovery";
    return this.http.post<any>(apiRegisterUrl, {"principal": principal});
  }

  passwordRecover2(principal : any, password: any, token: any) : Observable<ResponseI> {
    let apiRegisterUrl = environment.API_URL + "/auth/PasswordReset";
    return this.http.post<any>(apiRegisterUrl, {"principal": principal.replaceAll(' ', '+'), "password": password, "token": token});
  }

  changePassword(oldPassword : string, newPassword: string, confirmNewPassword: string) : Observable<ResponseI> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + (isPlatformBrowser(this.platformId) ? localStorage.getItem('token') : '')
    })
    let apiRegisterUrl = environment.API_URL + "/auth/ChangePassword";
    return this.http.post<any>(apiRegisterUrl, {"oldPassword": oldPassword, "newPassword": newPassword, "confirmNewPassword": confirmNewPassword}, {headers: headers});
  }

  validateEmail(token: any, email: any) {

    let enviar = {
      principal: email.replaceAll(' ', '+'),
      token: token
    }

    let apiRegisterUrl = environment.API_URL + "/auth/EmailVerification";
    return this.http.post<any>(apiRegisterUrl, enviar);
  }

  uploadAvatar(body: any): any {
    const avatarUrl = environment.API_URL + `/auth/SaveAvatar`;
    return this.http.post(avatarUrl, body);
  }

  update(newData: any){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + (isPlatformBrowser(this.platformId) ? localStorage.getItem('token') : '')
    })
    let apiUpdateUrl = environment.API_URL + "/user";
    return this.http.put<any>(apiUpdateUrl, newData, {headers: headers});

  }

  getPerson(){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + (isPlatformBrowser(this.platformId) ? localStorage.getItem('token') : '')
    })
    let apiUpdateUrl = environment.API_URL + "/auth/GetPerson";
    return this.http.get<any>(apiUpdateUrl, {headers: headers});

  }

  getPersonPoints(): Observable<number> {
    const url = `${environment.API_URL}/Conversion/quantityPoints`;
  
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=utf-8',
      'Authorization': 'Bearer ' + (isPlatformBrowser(this.platformId) ? localStorage.getItem('token') : '')
    });
  
    const options = { headers: headers };
  
    return this.http.get<number>(url, options);
  }

  checkUserAccount(username: string): Observable<string> {
    const url = `${environment.API_URL}/user/validateUser`;
    const params = new HttpParams().set('condition', username);
  
    return this.http.get<string>(url, { params, responseType: 'text' as 'json' });
  }

  completeRegister(data: any): Observable<any> {
    return this.http.put(`${environment.API_URL}/user/complete-register`, data);
  }
}
